let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g82cj")).then(() => parcelRequire('hwuOA'));